import { destroy } from 'redux-form';

export const ARTICLE_FORM_NAME = 'articleForm';

/**
 * Stable initialValues reference for redux-form: spreading `article` on every
 * connect() pass creates a new object each time, so with enableReinitialize
 * any form action (e.g. typing a translatable name) reinitializes from Redux
 * and wipes local edits.
 */
let memoized_initial_values_article_ref = null;
let memoized_initial_values = {};
const EMPTY_ARTICLE_FORM_INITIAL = {};

export function reset_article_form_initial_values_memo() {
    memoized_initial_values_article_ref = null;
    memoized_initial_values = {};
}

/** Drop every articleForm value (stocks, prices, names, …) and the initialValues memo. */
export function clear_article_form_session(dispatch) {
    reset_article_form_initial_values_memo();
    dispatch(destroy(ARTICLE_FORM_NAME));
}

export function get_article_form_initial_values(article) {
    if (!article)
        return EMPTY_ARTICLE_FORM_INITIAL;
    const same_ref = article === memoized_initial_values_article_ref;
    const same_id = article._id === memoized_initial_values._id;
    if (!same_ref || !same_id) {
        memoized_initial_values_article_ref = article;
        const stamp = (stock) => ({
            ...stock,
            expected_availability: stock.availability,
        });
        memoized_initial_values = {
            ...article,
            pos: (article.pos || []).map((p) => p._id ? p._id : p),
            attributes: JSON.parse(JSON.stringify(article.attributes || [])),
            stocks: (article.stocks || []).map(stamp),
            variants: article.variants
                ? article.variants.map((variant) => ({
                    ...variant,
                    stocks: (variant.stocks || []).map(stamp),
                }))
                : article.variants,
        };
    }
    return memoized_initial_values;
}
